import ApiEndpoints from "./apiConfig";

export const urlRecentComments = ApiEndpoints.recentComments;
export const urlSleeveComments = ApiEndpoints.sleeveComments;
export const urlPostSleeveComment = ApiEndpoints.postSleeveComment;

export const getRecentComments = (axios) => axios.get(`${urlRecentComments}`);
export const getSleeveComments = (axios, id) => axios.get(`${urlSleeveComments}/${id}`);
export const postSleeveComment = (axios, payload) => axios.post(`${urlPostSleeveComment}`, payload);
